module.exports = {
	"classes": [
		"whitehat-page",
		"header-dark"
	],
	"title": "Whitehat",
	"metas": {
		"description": "Responsible Disclosure Program and Security Researcher Hall of Fame."
	},
	"opengraph": {},
	"twittercard": {}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/whitehat/metadata.json
// module id = 1438
// module chunks = 0